export const isLoading = (state, actions) =>
  actions.some(action => {
    const loadingState = state.loading[action] || {};
    return loadingState.status;
  });
